module.exports = __webpack_public_path__ + "img/stones.efd29519.png";